import moment from 'moment';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormTokensService {
  public tokens = [
    {
      name: '#PROVIDER_NAME#',
      title: 'Provider First & Last Name',
      required: true,
    },
    {
      name: '#PROVIDER_FIRST#',
      title: 'Provider First Name',
      required: true,
    },
    {
      name: '#PROVIDER_LAST#',
      title: 'Provider Last Name',
      required: true,
    },
    {
      name: '#CLIENT_FIRST_LAST#',
      title: 'Client First & Last Name',
      required: true,
    },
    {
      name: '#CLIENT_FIRST_NAME#',
      title: 'Client First Name',
      required: true,
    },
    {
      name: '#CLIENT_LAST_NAME#',
      title: 'Client Last Name',
      required: true,
    },
    {
      name: '#CLIENT_MIDDLE_NAME#',
      title: 'Client Middle Name',
      placeholder: 'Please type Middle Name',
      required: false,
    },
    {
      name: '#DOB#',
      title: 'Client Date Of Birth',
      required: true,
    },
    // {
    //     name: '#SEX#',
    //     title: 'Client Sex',
    //     placeholder: 'Please type Sex',
    //     required: false
    // },
    // {
    //     name: '#ADDRESS1#',
    //     title: 'Client Address 1',
    //     required: false
    // },
    // {
    //     name: '#ADDRESS2#',
    //     title: 'Client Address 2',
    //     required: false
    // },
    // {
    //     name: '#CITY#',
    //     title: 'Client City',
    //     required: false
    // },
    // {
    //     name: '#STATE#',
    //     title: 'Client State',
    //     required: false
    // },
    // {
    //     name: '#ZIP#',
    //     title: 'Client Zip',
    //     placeholder: 'Please type Zip',
    //     required: false
    // },
    {
      name: '#PHONE#',
      title: 'Client Phone',
      placeholder: 'Please type Phone',
      required: false,
    },
    // {
    //     name: '#WORK_PHONE#',
    //     title: 'Client Work Phone',
    //     placeholder: 'Please type Work Phone',
    //     required: false
    // },
    // {
    //     name: '#HOME_PHONE#',
    //     title: 'Client Home Phone',
    //     placeholder: 'Please type Home Phone',
    //     required: false
    // },
    {
      name: '#EMAIL#',
      title: 'Client E-mail',
      placeholder: 'Please type Email',
      required: false,
    },
    {
      name: '#PRACTICE_NAME#',
      title: 'Clinic Name',
      required: true,
    },
    // {
    //     name: '#PRACTICE_PHONE#',
    //     title: 'Clinic Location',
    //     placeholder: 'Please type Clinic Phone',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_EMAIL#',
    //     title: 'Clinic Email',
    //     placeholder: 'Please type Clinic Email',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_LOCATION#',
    //     title: 'Clinic Location',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_ADDRESS_1#',
    //     title: 'Clinic Address 1',
    //     placeholder: 'Please type Clinic Address 1',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_ADDRESS_2#',
    //     title: 'Clinic Address 2',
    //     placeholder: 'Please type Clinic Address 2',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_CITY#',
    //     title: 'Clinic City',
    //     placeholder: 'Please type Clinic City',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_STATE#',
    //     title: 'Clinic State',
    //     placeholder: 'Please type Clinic State',
    //     required: false
    // },
    // {
    //     name: '#PRACTICE_ZIP#',
    //     title: 'Clinic ZIP code',
    //     placeholder: 'Please type Clinic Zip code',
    //     required: false
    // },
    {
      name: '#ECID#',
      title: 'ECID (External Chart ID)',
      placeholder: 'Missing ECID',
      required: false,
    },
    {
      name: '#CLIENT_ID#',
      title: 'Client ID',
      required: true,
    },
    {
      name: '#TODAY#',
      title: "Today's Date",
      required: true,
    },
  ];

  private sanitizeTokenText(value): string {
    const stringValue = value === null || value === undefined ? '' : String(value);

    return stringValue.replace(/[\u0000-\u001F\u007F]/g, '').trim();
  }

  private formatTokenValue(value): string {
    return JSON.stringify(this.sanitizeTokenText(value)).slice(1, -1);
  }

  private replaceToken(result: string, token: string, value): string {
    return result.replace(new RegExp(token, 'g'), () => this.formatTokenValue(value));
  }

  // @TODO adding types
  public replace(person, doctor, result, is_eu_datetime_format = false) {
    person = person || {};
    doctor = doctor || {};
    doctor.clinic = doctor.clinic || {};
    const dateFormat = is_eu_datetime_format ? 'DD/MM/YYYY' : 'MM/DD/YYYY';

    const personFirstName = person.first_name || '';
    const personLastName = person.last_name || '';
    const personMiddleName = person.middle_name || '';
    const personEmail = person.email || '';
    const doctorFirstName = doctor.first_name || '';
    const doctorLastName = doctor.last_name || '';
    const clinicTitle = (doctor.clinic || {}).title || '';

    result = this.replaceToken(result, '#FIRST_LAST#', `${personFirstName} ${personLastName}`);
    result = this.replaceToken(
      result,
      '#CLIENT_FIRST_LAST#',
      `${personFirstName} ${personLastName}`,
    );
    result = this.replaceToken(
      result,
      '#FIRST_NAME#',
      personFirstName || 'Please input First name',
    );
    result = this.replaceToken(
      result,
      '#CLIENT_FIRST_NAME#',
      personFirstName || 'Please input First name',
    );
    result = this.replaceToken(result, '#LAST_NAME#', personLastName || 'Please input Last name');
    result = this.replaceToken(
      result,
      '#CLIENT_LAST_NAME#',
      personLastName || 'Please input Last name',
    );
    result = this.replaceToken(
      result,
      '#MIDDLE_NAME#',
      personMiddleName || 'Please input Middle name',
    );
    result = this.replaceToken(
      result,
      '#CLIENT_MIDDLE_NAME#',
      personMiddleName || 'Please input Middle name',
    );
    result = this.replaceToken(result, '#TODAY#', moment().format(dateFormat));
    result = this.replaceToken(
      result,
      '#DOB#',
      person.birth_date
        ? moment(person.birth_date).format(dateFormat)
        : 'Please input Date of Birth',
    );
    result = this.replaceToken(
      result,
      '#PHONE#',
      person.phone_number || 'Please input Client Phone',
    );

    result = this.replaceToken(result, '#ECID#', person.mrn || 'Please input External Chart ID');

    result = this.replaceToken(result, '#CLIENT_ID#', person.id);

    result = this.replaceToken(result, '#ADDRESS1#', 'Please input Client Address 1');
    result = this.replaceToken(result, '#ADDRESS2#', 'Please input Client Address 2');
    result = this.replaceToken(result, '#CITY#', 'Please input Client City');
    result = this.replaceToken(result, '#STATE#', 'Please input Client State');
    result = this.replaceToken(result, '#ZIP#', 'Please input Client Zip');
    result = this.replaceToken(result, '#WORK_PHONE#', 'Please input Client Work Phone');
    result = this.replaceToken(result, '#HOME_PHONE#', 'Please input Client Home Phone');
    result = this.replaceToken(result, '#EMAIL#', personEmail || 'Please input Client E-mail');

    result = this.replaceToken(
      result,
      '#PROVIDER_FIRST_LAST#',
      `${doctorFirstName} ${doctorLastName}`,
    );
    result = this.replaceToken(result, '#PROVIDER_FIRST#', doctorFirstName);
    result = this.replaceToken(result, '#PROVIDER_LAST#', doctorLastName);
    result = this.replaceToken(
      result,
      '#PRACTICE_NAME#',
      clinicTitle || 'Please input Clinic name',
    );
    result = this.replaceToken(result, '#PROVIDER_NAME#', `${doctorFirstName} ${doctorLastName}`);
    return result;
  }
}
